import ga4Api from '@/packages/jsapi/logger/ga4';
import { base64ToFile } from '@/pages/customize/utils';
import fabric from '@/pages/customize/utils/newFabric';
import { getUploadToken, uploadCustomizeInfo } from '@/services/rpc/customize';
import OSS from 'ali-oss';
import { Toast } from 'antd-mobile';
import { v4 as uuid } from 'uuid';

// 用户做一些编辑器的功能操作, 封装到这个util 类里面
let w = window.innerWidth;
class Util {
  public canvasIns: any;
  public canvasConfig: any;
  public image: string;
  public canvasData: any;
  public itemId: string;
  public isRedoing: boolean;
  public stateArr: any;
  public stateIdx: number;
  static isDesktop: any;
  constructor(canvasIns, canvasConfig, image, itemId, editObj) {
    this.canvasIns = canvasIns;
    this.canvasConfig = canvasConfig;
    this.image = image;
    this.itemId = itemId;
    this.isRedoing = false; // 记录画布状态, 是否是在绘画中
    this.stateArr = editObj.stateArr;
    this.stateIdx = 0;
  }

  public setCanvasData(canvasData) {
    this.canvasData = canvasData;
  }

  public async initClient() {
    const result: any = await getUploadToken();
    const client = new OSS({
      region: result.region,
      accessKeyId: result.accessKeyId,
      accessKeySecret: result.accessKeySecret,
      stsToken: result.securityToken,
      bucket: result.bucketName
    });
    return client;
  }

  // 上传图片, 获取图片url,
  public async getImage(dataUrl) {
    const w = window.innerWidth;
    const itemId = this.itemId;
    return new Promise<any>(async (resolve, reject) => {
      Toast.show({ icon: 'loading', content: 'Waiting', duration: 0 });
      const copy = new fabric.Canvas('copy');
      copy.setHeight(w);
      copy.setWidth(w * 1.4);
      const imageList: any = [];
      const client = await this.initClient();
      const currentCanvas = this.canvasIns;
      const json = currentCanvas.toJSON();
      copy.loadFromJSON(json, async () => {
        copy.renderAll();
        this.canvasIns.viewportTransform = [1, 0, 0, 1, 0, 0];
        const dataUrl1 = copy.toDataURL({
          format: 'png',
          quality: 1,
          multiplier: 4,
          top: this.canvasData.top,
          left: this.canvasData.left,
          width: this.canvasData.width,
          height: this.canvasData.height
        });

        const file1 = await base64ToFile(dataUrl);
        const file2 = await base64ToFile(dataUrl1);
        const mainImage = await client.put(`${uuid()}.png`, file1);
        const customizedImage = await client.put(`${uuid()}.png`, file2);
        imageList.push({
          mainImage: `https://order-refund.hhocool.com/${mainImage.name}`,
          customizedImage: `https://order-refund.hhocool.com/${customizedImage.name}`
        });
        copy.clear();
        if (window.location.host.indexOf('localhost') > -1) {
          const link = document.createElement('a');
          link.download = 'currentCanvas.png';
          link.href = dataUrl1;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        const templateId: string = await uploadCustomizeInfo({
          itemId,
          materialList: imageList
        });
        Toast.clear();
        resolve({
          templateId,
          imageUrl: imageList[0].mainImage
        });
      });
    });
  }

  // 增加原图背景
  public addOriginBg() {
    const i = new Image();
    i.setAttribute('crossOrigin', 'anonymous');
    i.src = this.image;
    i.onload = () => {
      Toast.clear();
      const fabricImage = new fabric.Image(i, {
        crossOrigin: 'anonymous'
      });
      this.canvasIns.setBackgroundImage(
        fabricImage,
        this.canvasIns.renderAll.bind(this.canvasIns),
        {
          top: this.canvasData.top,
          left: this.canvasData.left,
          cornerSize: 6,
          cornerStyle: 'circle',
          scaleX: this.canvasData.scaleX,
          scaleY: this.canvasData.scaleY,
          erasable: false
        }
      );
    };
  }
  // 增加背景模版
  public addRectBg(left, top, width, height) {
    let rect = new fabric.Rect({
      name: 'transparent_bg',
      top,
      left,
      width,
      height,
      fill: 'transparent',
      opacity: 1,
      selectable: false
    });
    return rect;
  }
  // 添加图片
  shapeBg(currentCanvas) {
    let w = window.innerWidth;
    const shapeBg = new fabric.Rect({
      width: w,
      height: w * 2,
      left: 0,
      top: 0,
      myFabricType: 'bg',
      selectable: false // 禁止选中
    });
    currentCanvas.add(shapeBg);
    const url = 'https://static.hhocool.com/images/e91db416-3f32-415c-a78d-c597fa7fb69e_18x18.png';
    fabric.util.loadImage(url, function (img) {
      // 对 rect 进行图片填充，设置 repeat 为 重复
      shapeBg.set(
        'fill',
        new fabric.Pattern({
          source: img,
          repeat: 'repeat'
        })
      );
      // 渲染
      currentCanvas.renderAll();
    });
  }

  // 增加历史操作
  addHis() {
    this.stateIdx += 1;
  }

  updateRedoing(status) {
    this.isRedoing = status;
  }
  // 历史记录, 回退还原
  tapHistoryBtn(flag) {
    ga4Api({
      eventName: 'hho_review_view',
      params: {
        click: flag ? 'edit_redo' : 'edit_undo'
      }
    });
    this.isRedoing = true;
    let stateId = this.stateIdx + flag;
    if (stateId < 0) return;
    if (stateId >= this.stateArr.length) return;
    if (this.stateArr[stateId]) {
      this.canvasIns.loadFromJSON(
        this.stateArr[stateId],
        this.canvasIns.renderAll.bind(this.canvasIns),
        function (o, object) {
          object.selectable = false;
        }
      );
      this.stateIdx = stateId;
    }
  }
}

export default Util;
